import PageManager from '../page-manager';

export default class Errors404 extends PageManager {}




// WEBPACK FOOTER //
// ./assets/js/theme/404-error.js